/**
 * LD Cart Cross-Sell - Cross-sell product functionality
 */

class LDCartCrossSell {
  constructor(cartDrawer) {
    this.cartDrawer = cartDrawer;
  }

  // Method to add cross-sell product to cart
  async addCrossSellProduct(productId) {
    console.log(`LD Cart Cross-Sell: Adding cross-sell product ${productId} to cart`);
    
    try {
      // First get the product to find the default variant
      const productResponse = await fetch(`/products/${productId}.js`);
      const productData = await productResponse.json();
      
      if (productData.variants && productData.variants.length > 0) {
        const defaultVariant = productData.variants[0];
        console.log('LD Cart Cross-Sell: Adding default variant:', defaultVariant);
        
        // Add the default variant to cart
        await this.cartDrawer.addToCartAndShow(defaultVariant.id, 1);
      } else {
        console.error('LD Cart Cross-Sell: No variants found for product');
      }
    } catch (error) {
      console.error('LD Cart Cross-Sell: Error adding cross-sell product:', error);
    }
  }

  // Check if cross-sell section should be visible
  shouldShowCrossSell(cartItemCount, crossSellProductsCount) {
    // Show cross-sell if there are available products, regardless of cart content
    return crossSellProductsCount > 0;
  }

  // Get cross-sell products count
  getCrossSellProductsCount(crossSellProducts, cartItems = []) {
    let count = 0;
    
    if (crossSellProducts && crossSellProducts.length > 0) {
      for (const product of crossSellProducts) {
        const productsInCart = cartItems.filter(item => item.product_id === product.id);
        
        if (productsInCart.length === 0 && product.available) {
          count++;
        }
      }
    }
    
    return count;
  }
}

// Make class globally available
window.LDCartCrossSell = LDCartCrossSell;
